/* eslint-disable no-continue */
import { ConditionalStep } from 'config/utils/types';
import { AnswersState } from 'schemas/answerStateSchema';
import { AnswerKeys } from 'store/answers/answersSlice';
import { notifySentry } from './error/notifySentry';

function isArrayDefined(answerState: AnswersState, keys: AnswerKeys[]) {
  return keys.every((key) => answerState[key] !== undefined);
}

export default function checkIfAllRequiredAnswersAreDefined(
  steps: ConditionalStep[],
  currentRoute: string,
  answerState: AnswersState
) {
  const currentStep = steps.find((step) => step.step === currentRoute);
  if (!currentStep) {
    return true;
  }

  const notifyIssue = (requiredKeys: AnswerKeys[], message: string) => {
    // TODO: later see if we keep this as an exception or not? For now it is as the users is going back to the HOME SCREEN
    const errorDetail = {
      answerState,
      requiredKeys: JSON.stringify(requiredKeys),
      message,
      currentRoute,
    };
    notifySentry(new Error('SanityCheck Error'), errorDetail);
  };

  for (
    let idx = 0;
    idx < steps.length && steps[idx].step !== currentStep.step;
    idx += 1
  ) {
    const requiredKeys = steps[idx].answerKeys;
    if (!requiredKeys) {
      continue;
    }
    if (typeof requiredKeys === 'string') {
      if (!isArrayDefined(answerState, [requiredKeys])) {
        notifyIssue([requiredKeys], 'string not defined');
        return false;
      }
      continue;
    } else if (Array.isArray(requiredKeys)) {
      // NOTE: starting here we know it's an array
      if (requiredKeys.length === 0) continue;
      if (typeof requiredKeys[0] === 'string') {
        if (!isArrayDefined(answerState, requiredKeys as AnswerKeys[])) {
          notifyIssue(requiredKeys as AnswerKeys[], 'array not defined');
          return false;
        }
      } else if (Array.isArray(requiredKeys[0])) {
        // NOTE: this means that one of the arrays has to have all it's elements defined
        const isOneOfTheArraysDefined = requiredKeys.some((arr) =>
          isArrayDefined(answerState, arr)
        );
        if (!isOneOfTheArraysDefined) {
          notifyIssue(
            requiredKeys as AnswerKeys[],
            'none of the array defined'
          );
          return false;
        }
      }
    }
  }
  return true;
}
